/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ShopifyPaymentStatusFilter {
  PAID="PAID",
PENDING="PENDING",
AUTHORIZED="AUTHORIZED",
PARTIALLY_PAID="PARTIALLY_PAID",
PARTIALLY_REFUNDED="PARTIALLY_REFUNDED",
REFUNDED="REFUNDED",
VOIDED="VOIDED",
EXPIRED="EXPIRED"
}

/**
* ShopifyPaymentStatusFilter
*/
export const ShopifyPaymentStatusFilterEnumType = types.enumeration("ShopifyPaymentStatusFilter", [
        "PAID",
  "PENDING",
  "AUTHORIZED",
  "PARTIALLY_PAID",
  "PARTIALLY_REFUNDED",
  "REFUNDED",
  "VOIDED",
  "EXPIRED",
      ])
